import React, {useState, useEffect} from 'react';
import {Box} from "@chakra-ui/react"
import {staticDataTwo, staticData} from "../../helpers/adminData";
import Hero from "../../componetns/Hero"
import AboutUs from "../../componetns/AboutUs"
import OurCompetencies from "../../componetns/OurСompetencies";
import OurSkills from "../../componetns/OurSkills"
import Services from "../../componetns/Services"
import Gallery from "../../componetns/Gallery"
import Advantages from "../../componetns/Advantages"
import Contacts from "../../componetns/Contacts"
import ProcessControl from "../../componetns/ProcessControl"
import "../../componetns/style/style.css"
import Loading from "../../componetns/Loading";

const Home = () => {
    const [load, setLoad] = useState(true)
    useEffect(() => {
        setTimeout(() => (
            setLoad(false)
        ),600)
    }, [])
    return (
        <>
            {load ? (<Loading/>) : (
                <Box mt={{base: "82px", lg: "76px"}} mb="200px">
                    <Hero/>
                    <AboutUs/>
                    <OurSkills/>
                    <OurCompetencies
                        heading={`Мы поставляем отливки, массой до 2 тонн`} highlight={`массой до 2 тонн`}
                        text={"Для горнодобывающих, горно-перерабатывающих предприятий и для других видов производств."}
                        headingTwo={"Инновационный метод литья "}
                        span={"Позволяет получать высококачественные отливки c низкой шероховатостью поверхности. "}
                        staticData={staticDataTwo}
                        bg={"#EEEEEE"}
                        radius={"20px"} p={{base: "36px 15px", lg: "93px 61px"}} padding={{base: "0 15px", lg: "0"}}
                    />
                    <Gallery/>
                    <ProcessControl/>
                    <OurCompetencies
                        heading={`Термическая электропечь с выдвижным подом`} highlight={"электропечь"}
                        text={"Позволяет выполнять термообработку до двух тонн отливок одновременно"}
                        headingTwo={"Термическая обработка получаемых отливок "}
                        span={"Термообработка проводится в электропечи с программным управлением, что обеспечивает строгое соблюдение технологических режимов для любых марок сталей."}
                        staticData={staticData}
                        bg={"none"}
                        radius={"0"} p={{base: "4", md: "0"}}
                    />

                    <Services/>
                    <Advantages/>
                    <Contacts/>
                </Box>
            )}
        </>
    );
};

export default Home;
